export const clientKey = (window.AMZ_ENV?.VITE_PG_TOSS_CLIENT_KEY ?? "") as string;
export const variantKey = (window.AMZ_ENV?.VITE_PG_TOSS_VARIANT_KEY ?? "") as string;
